<template>
  <main class="main page-inside payment-result-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="title">
            {{
              $t(
                "Your payment is being processed. The status will update within a few minutes. In case of any questions, please contact us at"
              )
            }}
            {{ $parent.settings.support_email }}
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "PaymentPendingPage",
  props: [],
  components: {},
  data: function () {
    return {};
  },
  methods: {},
};
</script>
